import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
});

export default new Vuex.Store({
    state: {
        corporation: null,
        corporationInfo: {},
        sessionManageCalled: false,
        isLoggedIn: false,
        user: null,
        stayAliveData: {},
        hasEnroll: false,
        idCourseSeat: null,
    },
    mutations: {
        setCorporation(state, data) {
            state.corporation = data;
        },
        toggleSessionManageCalled(state) {
            state.sessionManageCalled = !state.sessionManageCalled;
        },
        setIsLoggedIn(state, isLoggedIn) {
            state.isLoggedIn = isLoggedIn;
        },
        setUser(state, user) {
            state.user = user;
        },
        setCorporationInfo(state, corporationInfo) {
            state.corporationInfo = corporationInfo;
        },
        setStayAliveData(state, stayAliveData) {
            state.stayAliveData = stayAliveData;
        },
        setHasEnroll(state, hasEnroll) {
            state.hasEnroll = hasEnroll;
        },
        setIdCourseSeat(state, idCourseSeat) {
            state.idCourseSeat = idCourseSeat;
        },
        clearIdCourseSeat(state) {
            state.idCourseSeat = null;
        },
    },
    actions: {},
    modules: {},
    plugins: [vuexLocal.plugin],
});